<div class="expansion-panel-wrapper" [ngStyle]="style">
  <p-accordion (onOpen)="isExpanded.emit(true)" (onClose)="isExpanded.emit(false)">
    <p-accordionTab>
      <ng-template pTemplate="header">
        <ui-input-checkbox
          [label]="checkboxLabel"
          [labelIcon]="labelIcon"
          [messagePad]="0"
          [(ngModel)]="checkboxValue"
          (change)="checkboxChange.emit(checkboxValue)"
          [tabindex]="0"
          [attr.aria-label]="checkboxLabel"
          [attr.aria-selected]="checkboxValue"
          (keydown.enter)="onCheckboxEnter($event)"
        ></ui-input-checkbox>
      </ng-template>
      <ng-template pTemplate="content">
        <ng-content></ng-content>
      </ng-template>
    </p-accordionTab>
  </p-accordion>
</div>
